import styled from "styled-components";

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column; /* Stack items vertically */
  padding: 24px 12px;
  justify-content: flex-start;
  align-items: flex-start; /* Center items horizontally */
  gap: 10px;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  margin: 24px 24px 0 24px;

  .hello-text {
    color: #585858;
    font-size: 24px;
    font-weight: 500;
  }

  .structure-text {
    color: #585858;
    font-size: 18px;
    font-weight: 500;
  }

  .select-tags-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 15px;
    width: 100%;
  }
`;

export const SmallText = styled.p`
  color: #949494;
  font-size: 10px;
  font-weight: 400;
  margin: 10px 0;
`;
export const ButtonContainer = styled.div`
  margin-top: auto;
`;
export const DisplayCards = styled.div`
  display: flex;
  gap: 24px;
  padding: 24px 24px;
  // min-width: 100%;
  // width: 100%
`;
export const DashboardCard = styled.div`
  flex: 1;
  width: 40%;
  // height: 263px;
  border-radius: 12px;
  background: ${(props) => props.bgColor || "#E8FFFC"};
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.15);
`;
export const Date = styled.div`
  display: inline-flex;
  padding: 2px 24px 2px 12px;
  align-items: center;
  gap: 10px;
  border-radius: 0px 8px 8px 0px;
  background: ${(props) => props.bgColor || "#017171"};
  color: #fff;
  // font-family: Noto Sans;
  font-size: 15px;
  // font-style: normal;
  font-weight: 500;
  // line-height: normal;
  margin-top: 22px;
`;
export const NationalLevelLabel = styled.p`
  color: #444;
  font-size: 14px;
  font-weight: 500;
  padding-left: 18px;
`;
export const AggregatedText = styled.p`
  color: ${(props) => props.color || "#017171"};
  font-size: 14px;
  font-weight: 600;
  text-align: center;
`;
export const DisplayInnerCards = styled.div`
  display: flex;
  gap: 5px;
  // border: 1px solid black;
`;
export const InnerCards = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 50%;
  // height: 113px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: ${(props) => props.bgColor || "#519C9C"};
  margin: 0 auto 25px auto;
`;
export const InnerCardsText = styled.p`
  color: #fff;
  font-size: 12px;
  font-weight: 400;
`;
export const InnerCardsTextNumber = styled.p`
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin: 0 auto;
  padding-bottom: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 85%;

  position: relative;

  &:hover::before {
    content: attr(title);
    position: absolute;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 5px;
    border-radius: 5px;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    white-space: normal; 
    z-index: 1;
  },
`;
export const BarChartContainer = styled.div`
  // border-radius: 12px;
  padding: 24px;
  filter: drop-shadow(0px 0px 12px rgba(0, 0, 0, 0.15));
`;
export const PieChartContainer = styled.div`
  display: flex;
  gap: 20px;
  // border-radius: 12px;
  // background: #FFF;
  // box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.15);
  // padding: 24px;
  // margin-left: 24px;
  // flex: 1;
  // width: 70%
`;
export const DualChartContainer = styled.div`
  border-radius: 12px;
  background: #fff;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.15);
  padding: 24px;
  margin-left: 24px;
  width: 70%;
`;
export const PaymentGatewayContainer = styled.div`
  border-radius: 12px;
  background: #fff;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.15);
  padding: 24px;
  margin-left: 24px;
  width: 70%;
`;
export const PieChartCardContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
`;
export const PieChartCard = styled.div`
  // width: 100%;
  width: 152px;
  height: 104px;
  // height: 100px;
  border-radius: 4px;
  background: linear-gradient(180deg, #a08ff4 0%, #5b45b2 100%);
  background: ${(props) =>
    props.bgColor || "linear-gradient(180deg, #A08FF4 0%, #5B45B2 100%)"};
`;
export const PieChartInnerCardContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  padding: 20px 10px 0px 10px;
`;
export const PieChartInnerCardText = styled.p`
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  margin: 0 0;
`;
export const PieChartInnerCardAmmount = styled.p`
  color: #fff;
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  // max-width: 100px;
`;

export const CircularProgressBarContainer = styled.div`
  // display: flex;
  // justify-content: center;
  // align-items: center;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.15);
  padding: 24px;
  margin-left: 5px;
  border-radius: 12px;
  width: 30%;
`;
export const GoalText = styled.p`
  color: #585858;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  margin: 0 0;
`;
export const NationalLevelText = styled.p`
  color: #444;
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 30px 0;
`;
